"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerDisplay = void 0;
const react_1 = __importDefault(require("react"));
const Box_1 = require("../box/Box");
const DrawerDisplay = ({ appBarContent, mainContent, drawerContent, anchor }) => (react_1.default.createElement(Box_1.Box, { sx: { display: 'flex' } },
    appBarContent,
    anchor === 'left' && drawerContent,
    mainContent,
    anchor === 'right' && drawerContent));
exports.DrawerDisplay = DrawerDisplay;
//# sourceMappingURL=DrawerDisplay.js.map